module.exports = __webpack_public_path__ + "static/media/ic-back-small.b90b0656.svg";